<template>
	<div class="vip-list">
		<!-- ========== KPI概览条：承载总量/余额/充值/退款四个高频口径 ========== -->
		<div class="kpi-row">
			<lcsj-stat-card label="会员总数" :value="stat.totalCount" unit=" 人" accent="primary" tip="当前筛选条件下的会员数量" />
			<lcsj-stat-card label="账户余额合计" :value="stat.totalBalance" prefix="￥" :decimals="2" accent="success" />
			<lcsj-stat-card label="本页充值合计" :value="pageSummary.recharge" prefix="￥" :decimals="2" accent="warning" desc="当前筛选结果合计" />
			<lcsj-stat-card label="本页消费合计" :value="pageSummary.consume" prefix="￥" :decimals="2" accent="danger" desc="当前筛选结果合计" />
		</div>

		<!-- ========== 折叠式筛选：常用 4 项 + 更多筛选 ========== -->
		<lcsj-filter more-text="更多筛选（余额区间、顾客）" @search="inputChange()" @reset="handleReset">
			<template #common>
				<el-form-item label="所属门店">
					<el-select v-model="formInline.storeKeyId" placeholder="全部门店" clearable filterable size="small" @change="handleStoreChange">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="会员号">
					<el-input v-model="formInline.vipNo" placeholder="请输入会员号" clearable size="small" @keyup.enter.native="inputChange()"></el-input>
				</el-form-item>
				<el-form-item label="手机号">
					<el-input v-model="formInline.customerPhone" placeholder="请输入手机号" clearable size="small" @keyup.enter.native="inputChange()"></el-input>
				</el-form-item>
				<el-form-item label="会员状态">
					<el-select v-model="formInline.vipStateStr" placeholder="全部状态" clearable size="small">
						<el-option v-for="item in vipStateOptions" :key="item" :label="item" :value="item"></el-option>
					</el-select>
				</el-form-item>
			</template>

			<template #actions>
				<el-upload
					v-if="$checkBtnPermission('/vip/manage', 'import')"
					ref="uploadbatch"
					:headers="myHeaders"
					:multiple="false"
					accept=".xls, .xlsx"
					action="/api/sysConfig/Vip/ImportVipInfoExcel"
					:on-success="handleImportClick"
					:show-file-list="false"
					class="vip-list__upload"
				>
					<template #trigger>
						<el-button size="small" icon="el-icon-upload2">上传</el-button>
					</template>
				</el-upload>
			</template>

			<template #more>
				<el-form-item label="余额下限">
					<el-input v-model="formInline.lessMoney" placeholder="下限" clearable size="small" class="vip-list__money-input"></el-input>
					</el-form-item>
				<el-form-item label="余额上限">
					<el-input v-model="formInline.moreMoney" placeholder="上限" clearable size="small" class="vip-list__money-input"></el-input>
				</el-form-item>
				<el-form-item label="顾客">
					<el-select v-model="formInline.customerKeyId" placeholder="请选择顾客" clearable filterable size="small" @change="inputChange">
						<el-option v-for="item in customerInfoList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
			</template>
		</lcsj-filter>

		<!-- ========== 表格：行内文字链 + 状态 pill + 本页汇总行 ========== -->
		<div class="table-minheight">
			<STable :columns="columnsData" :data="displayList" :loading="loading" border stripe>
				<el-table-column slot="customerInfo.gender" align="center" label="性别" min-width="90">
					<template #default="scope">
						<span v-if="scope.row.customerInfo && scope.row.customerInfo.gender == 1" class="one_1">
							{{ formatterFre(scope.row.customerInfo.gender) }}
						</span>
						<span v-if="scope.row.customerInfo && scope.row.customerInfo.gender == 0" class="one_2">
							{{ formatterFre(scope.row.customerInfo.gender) }}
						</span>
					</template>
				</el-table-column>
				<template #vipNo>
					<el-table-column align="center" label="会员卡编号" min-width="150">
						<template #default="scope">
							<span class="lcsj-link" @click="handleShowCardChangeHistory(scope.row)">{{ scope.row.vipNo }}</span>
						</template>
					</el-table-column>
				</template>
				<template #vipStateStr>
					<el-table-column align="center" label="会员状态" min-width="100">
						<template #default="scope">
							<span :class="$cls.pill(scope.row.vipStateStr)">{{ scope.row.vipStateStr }}</span>
						</template>
					</el-table-column>
				</template>
				<template #operation>
					<el-table-column align="center" label="操作" min-width="200" fixed="right">
						<template #default="scope">
							<div class="lcsj-row-actions">
								<button v-if="btnPermission.create" class="lcsj-row-actions__link" @click="handleCreateRecharge(scope.row)">充值</button>
								<button v-if="btnPermission.changeCardNo" class="lcsj-row-actions__link" @click="handleChangeCardNo(scope.row)">修改卡号</button>
								<button v-if="btnPermission.returnCard && scope.row.balance > 0" class="lcsj-row-actions__link lcsj-row-actions__link--danger" @click="handleCardReturn(scope.row)">退卡</button>
							</div>
						</template>
					</el-table-column>
				</template>
			</STable>

			<Pagination :show-pager="pageShow" :child-msg="pageparm" @call-father="callFather">
			<template #summary>
			<div class="lcsj-summary-row">
				<span class="lcsj-summary-row__label">本页合计（{{ displayList.length }} / {{ pageparm.total }} 条）</span>
				<span class="lcsj-summary-row__item">账户余额 <b :class="{ 'money-negative': pageSummary.balance < 0 }">￥{{ pageSummary.balance.toFixed(2) }}</b></span>
				<span class="lcsj-summary-row__item">总充值 <b>￥{{ pageSummary.recharge.toFixed(2) }}</b></span>
				<span class="lcsj-summary-row__item">总消费 <b>￥{{ pageSummary.consume.toFixed(2) }}</b></span>
			</div>

			</template>
			</Pagination>
		</div>

		<!-- ========== 会员充值：四段式弹窗（金额大卡 → 字段 → 支付宫格 → 汇总条） ========== -->
		<lcsj-dialog
			v-model="dialogVisible"
			title="会员充值"
			width="720px"
			confirm-text="确认充值"
			:confirm-loading="isSubmitting"
			footer-hint="充值后不可撤销，退卡需另行审批"
			custom-class="recharge-dialog"
			@confirm="handleSubmitVipRecharge"
		>
			<template #headerExtra>
				<span class="lcsj-pill lcsj-pill--info">{{ currentVipLabel }}</span>
			</template>

			<div class="recharge-dialog-content">
				<!-- 金额大卡 -->
				<div class="amount-card">
					<div class="amount-card__label">充值金额<span class="amount-card__req">*</span></div>
					<div class="amount-card__field">
						<span class="amount-card__symbol">￥</span>
						<el-input v-model.number="rechargeInfo.rechargeMoney" placeholder="0.00" class="amount-card__input"></el-input>
					</div>
					<div class="amount-card__quick">
						<button
							v-for="n in quickAmounts"
							:key="n"
							class="lcsj-chip"
							:class="{ 'is-on': Number(rechargeInfo.rechargeMoney) === n }"
							@click="rechargeInfo.rechargeMoney = n"
						>
							{{ n }}
						</button>
					</div>
				</div>

				<el-form :model="rechargeInfo" label-width="88px" size="small" class="recharge-form">
					<el-form-item label="赠送金额">
						<el-input v-model.number="rechargeInfo.bonusMoney" placeholder="0.00"></el-input>
						<div class="fld-hint">赠送金额不计入实收，余额 = 充值 + 赠送</div>
					</el-form-item>
					<el-form-item label="支付方式" prop="payTypes" required>
						<div class="pay-grid">
							<div
								v-for="(payTypeItem, index) in rechargeInfo.payTypes"
								:key="payTypeItem.payTypeId"
								class="pay-cell"
								:class="{ 'pay-cell--on': payTypeItem.payMoney > 0 }"
							>
								<span class="pay-cell__name">{{ payTypeItem.payTypeName }}</span>
								<el-input-number
									v-model.number="payTypeItem.payMoney"
									placeholder="0.00"
									:min="0"
									:step="1"
									:precision="2"
									size="small"
									controls-position="right"
								></el-input-number>
								<el-input v-model="payTypeItem.payComment" placeholder="备注" clearable size="small" class="pay-cell__remark"></el-input>
							</div>
						</div>
					</el-form-item>
				</el-form>

				<!-- 实时汇总条：充值后余额 -->
				<div class="amount-summary">
					<div class="amount-summary__item">
						<span class="amount-summary__label">充值金额</span>
						<span class="amount-summary__value">￥{{ Number(rechargeInfo.rechargeMoney || 0).toFixed(2) }}</span>
					</div>
					<div class="amount-summary__item">
						<span class="amount-summary__label">赠送金额</span>
						<span class="amount-summary__value">￥{{ Number(rechargeInfo.bonusMoney || 0).toFixed(2) }}</span>
					</div>
					<div class="amount-summary__item">
						<span class="amount-summary__label">充值后余额</span>
						<span class="amount-summary__value amount-summary__value--hl">￥{{ balanceAfterRecharge.toFixed(2) }}</span>
					</div>
				</div>
			</div>
		</lcsj-dialog>

		<!-- 会员退卡 -->
		<lcsj-dialog v-model="dialogReturnCardVisible" title="会员退卡" width="60%" confirm-text="确认退卡" :confirm-loading="isSubmitting" @confirm="handleSubmitVipReturnCard"><el-form :model="returnCardInfo" label-width="100px" size="small">
				<el-form-item label="退卡金额" required>
					<el-input v-model.number="returnCardInfo.returnMoney" placeholder="请输入退卡金额"></el-input>
				</el-form-item>
				<el-form-item label="退卡备注">
					<el-input v-model="returnCardInfo.remark" placeholder="请输入退卡备注" clearable></el-input>
				</el-form-item>
			</el-form>
		</lcsj-dialog>

		<!-- 修改会员卡号 -->
		<changeCardNo ref="changeCardNo" @success="getListData"></changeCardNo>
		<!-- 会员卡号修改记录弹窗 -->
		<cardChangeHistoryDialog ref="cardChangeHistoryDialog"></cardChangeHistoryDialog>
	</div>
</template>

<script>
import { GetCustomerVipPageList, SaveVipRecharge, VipReturnMoney } from "@/api/vipApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetCustomerListByStore } from "@/api/baseDataApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import changeCardNo from "@/views/vip/manage/changeCardNo.vue";
import cardChangeHistoryDialog from "@/views/vip/manage/cardChangeHistoryDialog.vue";
export default {
	data() {
		return {
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			selectionList: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				storeKeyId: "",
				customerKeyId: "",
				vipNo: "",
				customerPhone: "",
				lessMoney: "",
				moreMoney: "",
				vipStateStr: ""
			},
			// 充值弹窗快捷金额
			quickAmounts: [500, 1000, 2000, 5000, 10000],
			// 充值弹窗当前操作的会员快照（用于标题展示与余额试算）
			currentVip: {},
			storeList: [],
			columnsData: [],
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "70",
					isKeep: true
				},
				{
					prop: "createTime",
					label: "创建时间",
					width: "170",
					align: "center",
				},
				{
					prop: "storeName",
					label: "门店名称",
					isKeep: true,
					minWidth: "100",
					align: "center",
				},
				{
					prop: "customerInfo.name",
					label: "会员名称",
					minWidth: "100",
					align: "center"
				},
				{
					slot: "customerInfo.gender",
					label: "会员性别",
					align: "center"
				},
				{
					slot: "vipNo",
					label: "会员卡编号",
					minWidth: "120",
					align: "center"
				},
				{
					prop: "balance",
					label: "账户余额",
					align: "center",
					minWidth: "150",
					isMoney: true,
					moneyType: "income"
				},
				{
					prop: "customerInfo.phone",
					label: "会员电话",
					width: "120",
					align: "center"
				},
				{
					prop: "totalRecharge",
					label: "总充值金额",
					minWidth: "170",
					align: "center",
					isMoney: true,
					moneyType: "income"
				},
				{
					prop: "totalConsume",
					label: "总消费金额",
					minWidth: "170",
					align: "center",
					isMoney: true,
					moneyType: "normal"
				},
				{
					prop: "totalBonus",
					label: "总赠送金额",
					minWidth: "170",
					align: "center",
					isMoney: true,
					moneyType: "normal"
				},
				{
					prop: "lastBonus",
					label: "最后一次赠送金额",
					align: "center",
					minWidth: "180",
					isMoney: true,
					moneyType: "normal"
				},
				{
					slot: "vipStateStr",
					label: "会员状态",
					align: "center"
				},
				{
					prop: "creator",
					label: "创建人",
					width: "120",
					align: "center"
				},
				{
					slot: "operation",
					label: "操作",
					align: "center"
				}
			],
			btnPermission: {
				create: false,
				changeCardNo: false,
				returnCard: false
			},
			customerInfoList: [],
			dialogVisible: false,
			isSubmitting: false,
			rechargeInfo: {
				vipKeyId: "",
				rechargeMoney: 0,
				bonusMoney: 0,
				payTypes: []
			},
			payTypeList: [],
			totalMoney: 0,
			myHeaders: {},
			dialogReturnCardVisible: false,
			returnCardInfo: {
				keyId: "",
				returnMoney: 0,
				remark: ""
			}
		};
	},
	// 注册组件
	components: {
		changeCardNo,
		cardChangeHistoryDialog
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
		this.GetOrgInfoListByConfig();
		this.GetEnumConfigListByCode();
		// 按钮权限
		this.getBtnPermission();
		this.getToken();
	},
	computed: {
		/** 列表数据：按会员状态做前端过滤（后端 DTO 无此字段，不传接口） */
		displayList() {
			if (!this.formInline.vipStateStr) return this.listData;
			return this.listData.filter((item) => item.vipStateStr === this.formInline.vipStateStr);
		},
		/** 状态筛选项：从已加载数据中去重得出（不额外调接口） */
		vipStateOptions() {
			const set = new Set();
			this.listData.forEach((item) => {
				if (item.vipStateStr) set.add(item.vipStateStr);
			});
			return Array.from(set);
		},
		/** 会员总数（后端 total 优先，本页过滤时用本页长度） */
		totalCount() {
			return this.pageparm.total || this.displayList.length;
		},
		/** KPI 卡：全量余额合计（后端 totalMoney，接口已返回） */
		stat() {
			return {
				totalCount: this.totalCount,
				totalBalance: Number(this.totalMoney) || 0
			};
		},
		/** 本页汇总行：随快捷筛选联动 */
		pageSummary() {
			const sum = (field) => this.displayList.reduce((acc, item) => acc + (Number(item[field]) || 0), 0);
			return {
				balance: sum("balance"),
				recharge: sum("totalRecharge"),
				consume: sum("totalConsume")
			};
		},
		/** 充值弹窗标题展示的会员标识 */
		currentVipLabel() {
			if (!this.currentVip) return "";
			const name = (this.currentVip.customerInfo && this.currentVip.customerInfo.name) || "";
			return [name, this.currentVip.vipNo].filter(Boolean).join(" · ");
		},
		/** 充值后余额 = 原余额 + 充值 + 赠送 */
		balanceAfterRecharge() {
			const base = Number(this.currentVip && this.currentVip.balance) || 0;
			return base + (Number(this.rechargeInfo.rechargeMoney) || 0) + (Number(this.rechargeInfo.bonusMoney) || 0);
		}
	},
	methods: {
		// 重置筛选
		handleReset() {
			this.formInline.storeKeyId = "";
			this.formInline.customerKeyId = "";
			this.formInline.vipNo = "";
			this.formInline.customerPhone = "";
			this.formInline.lessMoney = "";
			this.formInline.moreMoney = "";
			this.formInline.vipStateStr = "";
			this.inputChange();
		},
		// 上传文档时组装token
		getToken() {
			let token = localStorage.getItem("logintoken");
			this.myHeaders = {
				Authorization: "Bearer " + token
			};
		},
		// 按钮权限
		getBtnPermission() {
			this.btnPermission.create = this.$checkBtnPermission("/vip/manage", "create");
			this.btnPermission.changeCardNo = this.$checkBtnPermission("/vip/manage", "changeCardNo");
			this.btnPermission.returnCard = this.$checkBtnPermission("/vip/manage", "returnCard");
		},
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						res.data.forEach((item) => {
							this.storeList.push({
								keyId: item.keyId,
								value: item.name + "【" + item.remark2 + "】"
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			// vipStateStr 为纯前端筛选字段（后端 DTO 未定义），传 null 避免被静默忽略造成误解
			const { vipStateStr, ...rest } = this.formInline;
			var params = {
				...rest,
				storeKeyId: this.formInline.storeKeyId || null,
				customerKeyId: this.formInline.customerKeyId || null
			};
			GetCustomerVipPageList(params)
				.then((res) => {
					this.totalMoney = res.totalMoney;
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.loading = false;
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 性别
		formatterFre(gender) {
			return gender == 1 ? "男" : gender == 0 ? "女" : "";
		},
		//获取状态信息
		GetEnumConfigListByCode() {
			const paramer = {
				code: "PayType"
			};
			GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.payTypeList = [];
						this.rechargeInfo.payTypes = [];
						res.data.forEach((item) => {
							//充值不允许使用会员卡销支付（后端规则：充值流程不扣储值卡余额），下拉与输入行中过滤
							if (parseInt(item.code) === 5) {
								return;
							}
							var payTypeId = parseInt(item.code);
							var payTypeName = item.name;
							this.payTypeList.push({
								payTypeId: payTypeId,
								payTypeName: payTypeName
							});
							this.rechargeInfo.payTypes.push({
								payTypeId: payTypeId,
								payTypeName: payTypeName,
								payMoney: 0,
								payComment: ""
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取状态信息失败!");
				});
		},
		// 充值
		handleCreateRecharge(row) {
			this.rechargeInfo.vipKeyId = row.keyId;
			this.rechargeInfo.rechargeMoney = 0;
			this.rechargeInfo.bonusMoney = 0;
			this.rechargeInfo.payTypes.forEach((item) => {
				item.payMoney = 0;
				item.payComment = "";
			});
			// 记录当前操作的会员，供弹窗标题展示与「充值后余额」实时试算
			this.currentVip = row;
			this.dialogVisible = true;
		},
		// 获取客户信息列表
		GetCustomerListByStore(val) {
			const paramer = {
				keyId: val
			};
			GetCustomerListByStore(paramer)
				.then((res) => {
					this.customerInfoList = [];
					if (res.code == 1) {
						this.customerInfoList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取客户信息失败!");
				});
		},
		// 提交充值
		handleSubmitVipRecharge() {
			var totalPayMoney = 0;
			var usedPayTypes = [];
			for (var i = 0; i < this.rechargeInfo.payTypes.length; i++) {
				var payTypeItem = this.rechargeInfo.payTypes[i];
				if (payTypeItem.payMoney <= 0) continue;
				var payMoney = parseFloat(payTypeItem.payMoney);
				if (isNaN(payMoney)) {
					this.$message.error("请输入有效的数字金额");
					return;
				}
				if (payMoney <= 0) {
					this.$message.error("支付金额不能小于0！");
					return;
				}
				if (payTypeItem.payTypeId == 5) {
					if (usedPayTypes.includes(payTypeItem.payTypeId)) {
						this.$message.error("会员卡销仅能支付一笔！");
						return;
					}
					usedPayTypes.push(payTypeItem.payTypeId);
				}
				payTypeItem.payMoney = parseFloat(payMoney.toFixed(2));
				totalPayMoney += payTypeItem.payMoney;
			}
			if (totalPayMoney <= 0) {
				this.$message.error("支付金额不能小于0！");
				return;
			}
			if (totalPayMoney > this.rechargeInfo.rechargeMoney) {
				this.$message.error("支付金额不能大于充值金额！");
				return;
			}
			SaveVipRecharge(this.rechargeInfo)
				.then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: "充值成功！"
						});
						this.dialogVisible = false;
						this.getListData();
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("充值失败，请稍后再试！");
				});
		},
		// 门店改变时获取客户列表
		handleStoreChange(val) {
			this.formInline.customerKeyId = "";
			if (val) {
				this.GetCustomerListByStore(val);
			} else {
				this.customerInfoList = [];
			}
		},
		// 文件上传成功的回调
		handleImportClick(event, file) {
			if (!event.data) {
				if (event.msg.includes("http")) {
					this.$message({
						type: "error",
						message: "导入的数据 部分有问题,数据已下载"
					});
					window.location.href = event.msg;
				} else {
					this.$message({
						type: "error",
						message: event.msg
					});
				}
			} else {
				this.$message({
					type: "success",
					message: "导入成功"
				});
				this.getListData();
			}
		},
		//展示退卡弹窗
		handleCardReturn(row) {
			this.returnCardInfo = {
				keyId: "",
				returnMoney: 0,
				remark: ""
			};
			this.returnCardInfo.keyId = row.keyId;
			this.dialogReturnCardVisible = true;
		},
		// 提交退卡
		async handleSubmitVipReturnCard() {
			if (this.isSubmitting) return;
			const input = this.returnCardInfo.returnMoney;
			const money = Number(input);
			if (input == null || String(input).trim() === '' || !Number.isFinite(money) || money < 0) {
				this.$message.error("请输入大于或等于0的有效退卡金额！");
				return;
			}
			const payload = { ...this.returnCardInfo, returnMoney: money };
			this.isSubmitting = true;
			try {
				try {
					await this.$confirm("确认退卡吗？", "提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning" });
					if (Math.round(money * 100) === 0) {
						await this.$confirm("本次退卡金额为0元，不退还款项，退卡后将清零该会员卡全部余额。是否仍要继续？", "0元退卡确认", {
							confirmButtonText: "确认0元退卡", cancelButtonText: "取消", type: "warning", closeOnClickModal: false
						});
					}
				} catch (_) { return; }
				const res = await VipReturnMoney(payload);
				if (res.code == 1) {
					this.$message({ type: "success", message: "退卡成功！" });
					this.dialogReturnCardVisible = false;
					this.getListData();
				} else {
					this.$message.error(res.msg);
				}
			} catch (_) {
				this.$message.error("退卡失败，请稍后再试！");
			} finally {
				this.isSubmitting = false;
			}
		},
		// 修改会员卡号
		handleChangeCardNo(row) {
			this.$refs.changeCardNo.getChangeDialog(row);
		},
		// 查看会员卡号修改记录
		handleShowCardChangeHistory(row) {
			this.$refs.cardChangeHistoryDialog.getHistoryDialog(row);
		}
	}
};
</script>

<style scoped>

.pay-types-container {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.pay-type-row {
	display: flex;
	align-items: center;
	padding: 8px 12px;
	background: var(--app-surface-muted);
	border-radius: 4px;
}

.pay-type-name {
	width: 80px;
	font-weight: 500;
	color: var(--app-text);
}

.recharge-dialog {
	.el-dialog__body {
		padding-top: 15px;
		padding-bottom: 10px;
		height: auto;
		max-height: none;
		overflow: visible;
	}
}

.recharge-dialog-content {
	width: 100%;
}

.recharge-form {
	.el-form-item {
		margin-bottom: 18px;
	}
}

.amount-row {
	display: flex;
	gap: 40px;
	margin-bottom: 20px;
}

.amount-item {
	flex: 1;
	display: flex;
	align-items: center;
	gap: 15px;
}

.amount-label {
	width: 100px;
	font-weight: 600;
	color: var(--app-text);
	font-size: 14px;
	flex-shrink: 0;
}

.amount-input {
	flex: 1;
	min-width: 200px;
}

.pay-types-horizontal {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.pay-types-row {
	display: flex;
	flex-wrap: wrap;
	gap: 15px;
}

.pay-type-item {
	display: flex;
	align-items: center;
	padding: 10px 15px;
	background: var(--app-surface-muted);
	border-radius: 6px;
	border: 1px solid var(--app-border);
	transition: all 0.3s ease;
	gap: 15px;
	width: calc(50% - 7.5px);
	box-sizing: border-box;

	&:hover {
		border-color: var(--app-primary);
		background: var(--app-primary-soft);
	}

	&-active {
		border-color: var(--app-primary);
		background: var(--app-primary-soft);
		box-shadow: 0 2px 8px 0 rgba(64, 158, 255, 0.15);
	}
}

.pay-type-label {
	width: 100px;
	font-weight: 600;
	color: var(--app-text);
	font-size: 14px;
	flex-shrink: 0;
}

.pay-types-row .el-input-number {
	width: 140px;
	flex-shrink: 0;
}

.pay-types-row .el-input {
	flex: 1;
	min-width: 100px;
}

.kpi-row {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 10px;
	margin-bottom: 12px;
}

.vip-list__upload {
	display: inline-block;
	margin-right: 4px;
}

.vip-list__money-input {
	width: 96px;
}

.vip-list__range-sep {
	color: var(--app-text-muted);
}

.lcsj-summary-row {
	display: flex;
	align-items: center;
	gap: 6px 18px;
	flex-wrap: wrap;
	font-size: var(--app-font-md);
	color: var(--app-text);
}

.lcsj-summary-row__label {
	color: var(--app-text-secondary);
	font-size: var(--app-font-base);
}

.lcsj-summary-row__item b {
	margin-left: 5px;
	font-weight: 600;
	font-variant-numeric: tabular-nums;
}

.amount-card {
	background: var(--app-surface-muted);
	border: 1px solid var(--app-border);
	border-radius: var(--app-radius);
	padding: 12px 14px;
	margin-bottom: 16px;
}

.amount-card__label {
	font-size: var(--app-font-base);
	color: var(--app-text-secondary);
	margin-bottom: 8px;
}

.amount-card__req {
	color: var(--app-danger-text);
	margin-left: 3px;
}

.amount-card__field {
	display: flex;
	align-items: center;
	gap: 8px;
}

.amount-card__symbol {
	font-size: 22px;
	font-weight: 700;
	color: var(--app-text);
}

.amount-card__input >>> .el-input__inner {
	font-size: 22px;
	font-weight: 700;
	height: 44px;
	border-color: var(--app-primary);
}

.amount-card__quick {
	display: flex;
	gap: 8px;
	margin-top: 10px;
	flex-wrap: wrap;
}

.fld-hint {
	font-size: var(--app-font-xs);
	color: var(--app-text-muted);
	line-height: 1.6;
	margin-top: 2px;
}

.pay-grid {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 8px;
	width: 100%;
}

.pay-cell {
	display: flex;
	align-items: center;
	gap: 8px;
	border: 1px solid var(--app-border);
	border-radius: var(--app-radius);
	padding: 8px 10px;
	background: var(--app-surface);
	transition: all 0.2s;
}

.pay-cell--on {
	border-color: var(--app-primary);
	background: var(--app-primary-soft);
}

.pay-cell__name {
	flex-shrink: 0;
	font-size: var(--app-font-base);
	color: var(--app-text);
	width: 56px;
}

.pay-cell__remark {
	flex: 1;
	min-width: 60px;
}

.pay-cell .el-input-number {
	width: 118px;
	flex-shrink: 0;
}

.amount-summary {
	display: flex;
	gap: 10px;
	margin-top: 14px;
	padding: 11px 14px;
	background: var(--app-primary-soft);
	border: 1px solid var(--app-primary-border);
	border-radius: var(--app-radius);
}

.amount-summary__item {
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 3px;
}

.amount-summary__label {
	font-size: var(--app-font-xs);
	color: var(--app-text-secondary);
}

.amount-summary__value {
	font-size: 17px;
	font-weight: 700;
	color: var(--app-text);
	font-variant-numeric: tabular-nums;
}

.amount-summary__value--hl {
	color: var(--app-primary-text);
}
</style>
